// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let React = require("react");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../systemMessages/SystemMessages.bs.js");
let Primitive_object = require("@rescript/runtime/lib/js/Primitive_object.js");
let AttachmentManager = require("./AttachmentManager.bs.js");
let Types__Attachment = require("../types/Types__Attachment.bs.js");

function isImage(t) {
  return t.startsWith("image/");
}

let ContentType = {
  isImage: isImage
};

function id(t) {
  let match = t.state;
  if (match.TAG === "Failed") {
    return match._0._0.id;
  } else {
    return match._0.id;
  }
}

function isImage$1(t) {
  let match = t.state;
  switch (match.TAG) {
    case "NotStarted" :
      return match._0.file.type.startsWith("image/");
    case "Failed" :
      let match$1 = match._0;
      if (match$1.TAG === "SignFailed") {
        return match$1._0.file.type.startsWith("image/");
      } else {
        return match$1._0.contentType.startsWith("image/");
      }
    case "InProgress" :
    case "Success" :
      return match._0.contentType.startsWith("image/");
  }
}

function fileName(t) {
  let match = t.state;
  switch (match.TAG) {
    case "NotStarted" :
      return match._0.file.name;
    case "Failed" :
      let match$1 = match._0;
      if (match$1.TAG === "SignFailed") {
        return match$1._0.file.name;
      } else {
        return match$1._0.fileName;
      }
    case "InProgress" :
    case "Success" :
      return match._0.fileName;
  }
}

function fromFile(file) {
  return {
    previewUrl: undefined,
    state: {
      TAG: "NotStarted",
      _0: file
    }
  };
}

function fromAttachment(attachment) {
  let previewUrl = attachment.contentType.startsWith("image/") ? Utils.makeAttachmentUrl(234, 170, false, undefined, undefined, undefined, attachment.key) : undefined;
  return {
    previewUrl: previewUrl,
    state: {
      TAG: "Success",
      _0: attachment
    }
  };
}

function isFailed(a) {
  let match = a.state;
  return match.TAG === "Failed";
}

function isInProgress(a) {
  let match = a.state;
  switch (match.TAG) {
    case "NotStarted" :
    case "InProgress" :
      return true;
    case "Failed" :
    case "Success" :
      return false;
  }
}

let Attachment = {
  ContentType: ContentType,
  id: id,
  isImage: isImage$1,
  fileName: fileName,
  fromFile: fromFile,
  fromAttachment: fromAttachment,
  isFailed: isFailed,
  isInProgress: isInProgress
};

function move(srcId, destId, list) {
  let src = Stdlib_Option.getOrThrow(Stdlib_List.find(list, x => Primitive_object.equal(srcId, id(x))), undefined);
  return Stdlib_List.reverse(Stdlib_List.reduceWithIndex(list, /* [] */0, (acc, e, index) => {
    let id$1 = id(e);
    let match = Primitive_object.equal(srcId, id$1);
    let match$1 = Primitive_object.equal(destId, id$1);
    if (match) {
      if (match$1) {
        return Stdlib_List.add(acc, e);
      } else {
        return acc;
      }
    }
    if (!match$1) {
      return Stdlib_List.add(acc, e);
    }
    let append = index > Stdlib_List.length(acc);
    if (append) {
      return Stdlib_List.add(Stdlib_List.add(acc, e), src);
    } else {
      return Stdlib_List.add(Stdlib_List.add(acc, src), e);
    }
  }));
}

function reducer(param, action) {
  let value = param.attachments;
  let attachments;
  if (typeof action !== "object") {
    attachments = /* [] */0;
  } else {
    switch (action.TAG) {
      case "AddFiles" :
        attachments = Stdlib_List.concat(value, Stdlib_List.fromArray(action._0.map(fromFile)));
        break;
      case "Delete" :
        let id$1 = action._0;
        attachments = Stdlib_List.filter(value, v => Primitive_object.notequal(id$1, id(v)));
        break;
      case "PreviewComplete" :
        let url = action._1;
        let id$2 = action._0;
        attachments = Stdlib_List.map(value, v => {
          if (Primitive_object.equal(id$2, id(v))) {
            return {
              previewUrl: url,
              state: v.state
            };
          } else {
            return v;
          }
        });
        break;
      case "Reorder" :
        attachments = move(action._0, action._1, value);
        break;
      case "Signed" :
        let attachment = action._0;
        attachments = Stdlib_List.map(value, v => {
          let match = v.state;
          if (match.TAG === "NotStarted" && Primitive_object.equal(match._0.id, attachment.id)) {
            return {
              previewUrl: v.previewUrl,
              state: {
                TAG: "InProgress",
                _0: attachment,
                _1: 0.0
              }
            };
          } else {
            return v;
          }
        });
        break;
      case "Progress" :
        let progress = action._1;
        let id$3 = action._0;
        attachments = Stdlib_List.map(value, v => {
          let match = v.state;
          if (match.TAG !== "InProgress") {
            return v;
          }
          let attachment = match._0;
          if (Primitive_object.equal(id$3, attachment.id)) {
            return {
              previewUrl: v.previewUrl,
              state: {
                TAG: "InProgress",
                _0: attachment,
                _1: progress
              }
            };
          } else {
            return v;
          }
        });
        break;
      case "UploadComplete" :
        let id$4 = action._0;
        attachments = Stdlib_List.map(value, v => {
          let match = v.state;
          if (match.TAG !== "InProgress") {
            return v;
          }
          let attachment = match._0;
          if (!Primitive_object.equal(id$4, attachment.id)) {
            return v;
          }
          let url = v.previewUrl;
          if (url !== undefined) {
            URL.revokeObjectURL(url);
          }
          return fromAttachment(attachment);
        });
        break;
      case "UploadError" :
        let error = action._1;
        let id$5 = action._0;
        attachments = Stdlib_List.map(value, v => {
          let f = v.state;
          switch (f.TAG) {
            case "NotStarted" :
              let f$1 = f._0;
              if (Primitive_object.equal(f$1.id, id$5)) {
                return {
                  previewUrl: v.previewUrl,
                  state: {
                    TAG: "Failed",
                    _0: {
                      TAG: "SignFailed",
                      _0: f$1,
                      _1: error
                    }
                  }
                };
              } else {
                return v;
              }
            case "InProgress" :
              let a = f._0;
              if (Primitive_object.equal(a.id, id$5)) {
                return {
                  previewUrl: v.previewUrl,
                  state: {
                    TAG: "Failed",
                    _0: {
                      TAG: "UploadFailed",
                      _0: a,
                      _1: error
                    }
                  }
                };
              } else {
                return v;
              }
            case "Failed" :
            case "Success" :
              return v;
          }
        });
        break;
    }
  }
  return {
    attachments: attachments
  };
}

function toAttachment(r) {
  return Types__Attachment.make(r.id, r.key, r.fileName, r.contentType);
}

function useAttachmentUploader(onChange, value) {
  let match = React.useReducer(reducer, {
    attachments: value
  });
  let reducer$1 = match[1];
  let state = match[0];
  React.useEffect(() => {
    onChange(state.attachments);
  }, [state]);
  let attachments = Stdlib_List.toArray(state.attachments);
  let addFiles = files => {
    let files$1 = files.map(param => ({
      id: param.id,
      file: param.file
    }));
    reducer$1({
      TAG: "AddFiles",
      _0: files$1
    });
  };
  let $$delete = id => reducer$1({
    TAG: "Delete",
    _0: id
  });
  let onChangePreview = (id, url) => reducer$1({
    TAG: "PreviewComplete",
    _0: id,
    _1: url
  });
  let reorder = (srcId, destId) => reducer$1({
    TAG: "Reorder",
    _0: srcId,
    _1: destId
  });
  let onUploadProgress = (id, progress) => reducer$1({
    TAG: "Progress",
    _0: id,
    _1: progress
  });
  let onSigned = attachment => reducer$1({
    TAG: "Signed",
    _0: toAttachment(attachment)
  });
  let onUploadComplete = id => reducer$1({
    TAG: "UploadComplete",
    _0: id
  });
  let onUploadError = (id, error) => reducer$1({
    TAG: "UploadError",
    _0: id,
    _1: error
  });
  let clearAll = () => reducer$1("ClearAll");
  return {
    addFiles: addFiles,
    attachments: attachments,
    delete: $$delete,
    onChangePreview: onChangePreview,
    onUploadProgress: onUploadProgress,
    onSigned: onSigned,
    onUploadComplete: onUploadComplete,
    onUploadError: onUploadError,
    reorder: reorder,
    clearAll: clearAll
  };
}

function makeUnsupportedFileErrorText(files) {
  let match = files.length;
  let subject = match !== 1 ? "The files" : "The file";
  let __x = files.map(x => x.file).map(prim => prim.name);
  let fileNames = Utils.$$Array.pseudoJoin(", ", " and ", __x).join("");
  let match$1 = files.length;
  let verb = match$1 !== 1 ? "are" : "is";
  return subject + ` ` + fileNames + ` ` + verb + ` not supported.`;
}

function useUnsupportedFilesSystemMessage() {
  let match = SystemMessages.useSystemMessages();
  let addMessage = match.addMessage;
  let makeMessage = files => SystemMessages.Message.make(undefined, "error", makeUnsupportedFileErrorText(files), 10000, undefined, undefined);
  return files => addMessage(makeMessage(files));
}

function useAttachments(onChange, value, onUnsupportedFileError) {
  let match = useAttachmentUploader(onChange, value);
  let addFiles = AttachmentManager.useAttachmentManager(match.addFiles, match.onChangePreview, match.onUploadProgress, match.onSigned, match.onUploadComplete, match.onUploadError, onUnsupportedFileError);
  return {
    add: addFiles,
    delete: match.delete,
    attachments: match.attachments,
    reorder: match.reorder,
    clearAll: match.clearAll
  };
}

exports.Attachment = Attachment;
exports.move = move;
exports.reducer = reducer;
exports.toAttachment = toAttachment;
exports.useAttachmentUploader = useAttachmentUploader;
exports.makeUnsupportedFileErrorText = makeUnsupportedFileErrorText;
exports.useUnsupportedFilesSystemMessage = useUnsupportedFilesSystemMessage;
exports.useAttachments = useAttachments;
/* Utils Not a pure module */
